'use strict';

if (document.querySelector('section.small-hero') || document.querySelector('article header .small-hero')) {
  var smallHero = {
    button: document.querySelector('section.small-hero .button-container') ?? document.querySelector('article header .small-hero .button-container'),
    clickHandler: function (event) {
      event.preventDefault();
      var container = event.srcElement.closest('section') ?? event.srcElement.closest('.small-hero');
      var yPosition = container.scrollTop + container.clientHeight;
      if (container.clientWidth < 1024) {
        yPosition = yPosition - 100;
      } else {
        yPosition = yPosition + container.offsetTop;
      }
      window.scrollTo({
        top: yPosition,
        left: 0,
        behavior: "smooth"
      });
      return false;
    },
    init: function () {
      smallHero.button.addEventListener('click', smallHero.clickHandler);
      return;
    }
  };
  smallHero.init();
}